function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 12.6667C8.44928 12.6667 7.60143 12.3155 6.97631 11.6904C6.35119 11.0652 6 10.2174 6 9.33333C6 8.44928 6.35119 7.60143 6.97631 6.97631C7.60143 6.35119 8.44928 6 9.33333 6C10.2174 6 11.0652 6.35119 11.6904 6.97631C12.3155 7.60143 12.6667 8.44928 12.6667 9.33333C12.6667 9.77107 12.5804 10.2045 12.4129 10.6089C12.2454 11.0134 11.9999 11.3808 11.6904 11.6904C11.3808 11.9999 11.0134 12.2454 10.6089 12.4129C10.2045 12.5804 9.77107 12.6667 9.33333 12.6667ZM9.33333 0C6.85798 0 4.48401 0.98333 2.73367 2.73367C0.98333 4.48401 0 6.85798 0 9.33333C0 16.3333 9.33333 26.6667 9.33333 26.6667C9.33333 26.6667 18.6667 16.3333 18.6667 9.33333C18.6667 6.85798 17.6833 4.48401 15.933 2.73367C14.1827 0.98333 11.8087 0 9.33333 0Z",
  fill: "#475572"
});

var SvgGrayMarker = function SvgGrayMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grayMarker.81188315.svg";
export { ForwardRef as ReactComponent };